import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

const CloseIcon = createSvgIcon(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.146 22.9282C18.2211 22.9282 23.146 18.0034 23.146 11.9282C23.146 5.85309 18.2211 0.928223 12.146 0.928223C6.07086 0.928223 1.146 5.85309 1.146 11.9282C1.146 18.0034 6.07086 22.9282 12.146 22.9282ZM15.3523 7.27732C15.7512 6.87843 16.3979 6.87843 16.7968 7.27732C17.1957 7.67621 17.1957 8.32294 16.7968 8.72184L13.5905 11.9281L16.7968 15.1345C17.1957 15.5334 17.1957 16.1801 16.7968 16.579C16.3979 16.9779 15.7512 16.9779 15.3523 16.579L12.146 13.3727L8.93965 16.579C8.54076 16.9779 7.89403 16.9779 7.49513 16.579C7.09624 16.1801 7.09624 15.5334 7.49513 15.1345L10.7014 11.9282L7.49513 8.72184C7.09624 8.32294 7.09624 7.67621 7.49513 7.27732C7.89403 6.87843 8.54076 6.87843 8.93965 7.27732L12.146 10.4836L15.3523 7.27732Z"
        />
    </svg>,
    'close'
);

export default CloseIcon;
